import { UseMutationResult, useMutation } from 'react-query'
import useLocation from 'react-use/lib/useLocation'
import useAxios from './useAxios'
import { Endpoints } from '../types/constants'

export enum EventNames {
  frontendVisit = 'frontend_visit',
  mobileFrontendVisit = 'frontend_mobile_visit',
  frontendResumeFileOnlyRepeatUpload = 'frontend_resume_file_only_repeat_upload',
  frontendResumeFileOnlyUpload = 'frontend_resume_file_only_upload',
  frontendResumeFileOnlyUploadFailure = 'frontend_resume_file_only_upload_failure',
  frontendResumeUpload = 'frontend_resume_upload',
  frontendResumeUploadFailure = 'frontend_resume_upload_failure',
  frontendEmailAddedToResumeUpload = 'frontend_email_added_to_resume_upload',
  frontendEmailAddedToResumeUploadFailure = 'frontend_email_added_to_resume_upload_failure',
  frontendMobileEmailUpload = 'frontend_mobile_email_upload',
  frontendMobileEmailUploadFailure = 'frontend_mobile_email_upload_failure',
  checkoutVisit = 'checkout_visit',
  mobileCheckoutVisit = 'checkout_mobile_visit',
}

type StatsInputSchema = {
  event: EventNames
  page?: string
  referrer?: string
}
type StatsOutputSchema = Omit<StatsInputSchema, 'page' | 'referrer'>

export function useStatsEvent(): UseMutationResult<
  void,
  unknown,
  EventNames,
  unknown
> {
  const { pathname: page } = useLocation()
  const axios = useAxios()
  return useMutation({
    mutationKey: Endpoints.Stats,
    mutationFn: async (event: EventNames) => {
      const data: StatsInputSchema = { event, page }
      await axios.post<StatsOutputSchema>(Endpoints.Stats, data)
    },
  })
}
